import { useMutation } from '@tanstack/react-query';
import axios from '../../axios';

const requestCertificate = async (listingId: string) => {
    const { data } = await axios.post(`/api/buyer/certificate-requests/${listingId}`);
    return data;
};

export const useRequestCertificate = () =>
    useMutation({
        mutationFn: (listingId: string) => requestCertificate(listingId),
    });
